import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import Breadcrumb from '../common/Breadcrumb'
import WrappedTabs from '../common/WrappedTabs'
import Policies from './policies'
import PolicyTypes from './policyTypes'
import './policies.scss'

function PoliciesPage() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const tabs = useMemo(
    () => [
      {
        key: 0,
        slug: 'policies',
        title: 'nav.policies',
        content: <Policies />,
      },
      {
        key: 1,
        slug: 'policy-types',
        title: 'policies.policy-type',
        content: <PolicyTypes />,
      },
    ],
    [],
  )

  const [activeTab, setActiveTab] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const contentParam = params.get('content')
    let selectedTab = tabs[0]

    if (contentParam) {
      const match = tabs.find((tab) => tab.slug === contentParam)
      if (match) selectedTab = match
    }
    setActiveTab(selectedTab)

    const expectedQuery = `?content=${selectedTab.slug}`
    if (location.search !== expectedQuery) {
      history.replace({ search: expectedQuery })
    }
  }, [location.search, history, tabs])

  const handleChangeTab = (tabKey) => {
    const tab = tabs.find((tab) => tab.key === tabKey)
    if (!tab) return
    setActiveTab(tab)
    history.push({ search: `?content=${tab.slug}` })
  }

  return (
    <div className="policy-page-wrapper">
      <Breadcrumb path={location.pathname} />
      <DashboardHeader headerText={t('nav.policies')} />
      <WrappedTabs tabs={tabs.map((tab) => ({ id: tab.key, name: tab.title }))} activeTab={activeTab?.key} changeTab={handleChangeTab} />
      {activeTab?.content}
    </div>
  )
}

export default PoliciesPage

